import * as yup from 'yup'

export const universitySchema = yup.object().shape({
  _id: yup.string().nullable(),
  universityId: yup.string().nullable(),
  universityName: yup.string().required("University name is required"),
  shortName: yup.string().required("University short name is required"),
  universityLogo: yup.string().required("University logo is required"),
  campusImages: yup.array().of(yup.string().url("Must be a valid URL").required("Image is required")).min(2,"Minimum 2 images are required"),
  websiteLink: yup.string().url("Must be a valid URL").nullable(),
  yearEstablished: yup.mixed().test(
    "yearEstablished-check",
    "Year of established is required",
    (val) => {
      if (!val) return false;
      if (typeof val === "string") {
        return val.trim().length > 0;
      }
      if (typeof val === "object" && val.value) {
        return val.value.trim().length > 0;
      }
      return false;
    }
  ),
  institutionType: yup.mixed().test(
    "institutionType-check",
    "Institution type value is required",
    (val) => {
      if (!val) return false;
      if (typeof val === "string") {
        return val.trim().length > 0;
      }
      if (typeof val === "object" && val.value) {
        return val.value.trim().length > 0;
      }
      return false;
    }
  ),
  accreditations: yup.array().of(
    yup.object().shape({
      accreditationId: yup.string().required("Accreditation ID is required"),
      data: yup.object().shape({
        score: yup.string().nullable(),
        grade: yup.string().nullable(),
        status: yup.string().nullable(),
      }),
      certificate: yup.string().nullable(),
    })
  ),
  country: yup.string().required("Country is required"),
  state: yup.string().required("State is required"),
  city: yup.string().required("City is required"),
  fullAddress: yup.string().nullable(),
  // postalCode: yup.string().nullable(),
postalCode: yup
  .string()
  .nullable()
  .test(
    "is-valid-postal",
    "Postal code must be exactly 6 digits",
    (value) => {
      if (!value) return true;  // allow empty (optional)
      return /^\d{6}$/.test(value);
    }
  ),
  contactEmail: yup.string().email("Invalid email format")
    .test("valid-or-empty", "Email must be valid", (value) => {
    if (!value) return true; // optional
    return (
      yup.string().email().isValidSync(value) &&
      /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(value)
    );
  }),
  telephoneNumber:  yup
  .string()
  .nullable()
  .notRequired()
  .matches(/^\+?[0-9-]*$/, "Only numbers, hyphens, and an optional + at the start are allowed")
  .test(
    "length-check",
    "Must be between 5 and 16 characters",
    (value) => {
      if (!value) return true; // ✔ allow empty (optional)
      return value.length >= 5 && value.length <= 16;
    }
  ),
  studentSupportLine:  yup
  .string()
  .nullable()
  .notRequired()
  .matches(/^\+?[0-9-]*$/, "Only numbers, hyphens, and an optional + at the start are allowed")
  .test(
    "length-check",
    "Must be between 5 and 16 characters",
    (value) => {
      if (!value) return true; // ✔ allow empty (optional)
      return value.length >= 5 && value.length <= 16;
    }
  ),
  socialMediaLinks: yup.lazy((val) => {
    if (val && typeof val === "object") {
      return yup.object().shape({
        facebook: yup.string().url("Invalid Facebook URL"),
        linkedin: yup.string().url("Invalid LinkedIn URL").nullable(),
        instagram: yup.string().url("Invalid Instagram URL").nullable(),
        youtube: yup.string().url("Invalid YouTube URL").nullable(),
      });
    }
    return yup.mixed().notRequired();
  }),
  universityOverview: yup.string().required("University overview is required"),
  reasonsToChooseUs: yup.array().of(yup.string().required("Description is required")),
  advantage: yup.array().of(yup.string().required("Description is required")),
  LeadershipandFacultyTeam: yup.array().of(
    yup.object().shape({
      professorName: yup.string().required("Professor name is required"),
      designation: yup.string().required("Designation is required"),
      // image: yup.string().url("Invalid image URL").required("Image is required"),
      image: yup.string().url("Invalid image URL").nullable(),
      experience: yup.string().required("Experience is required"),
      qualification: yup.string().required("Qualification is required"),
    })
  ),
  studentSpotlight: yup.array().of(
    yup.object().shape({
      studentName: yup.string().required("Student name is required"),
      testimonial: yup.string().required("Testimonial is required"),
      image: yup.string().url("Invalid image URL").nullable(),
      rating: yup.number().min(1).max(5).required("Rating is required"),
      courseName: yup.string().required("Course name is required"),
    })
  ),
  onlineLearningResources: yup.array().of(yup.string().required("Learning resource is required")),
  awardsandRecognitions: yup.array().of(
    yup.object().shape({
      title: yup.string().required("Award title is required"),
      year: yup.number().required("Year is required"),
      body: yup.string().required("Awarding body is required"),
      fileUrl: yup.string().url("Invalid file URL").nullable(),
    })
  ),
  careerServicesandPlacementSupport: yup.string().required("Career services and placement support is required"),
  uploadRelevantDocument: yup.array().of(
    yup.object().shape({
      title: yup.string().nullable(),
      file: yup.object(),
      url: yup.string().url("Invalid file URL").required("Attachment is required"),
    })
  ),
});
